import { render, staticRenderFns } from "./AttachmentViewModal.vue?vue&type=template&id=bede492c"
import script from "./AttachmentViewModal.vue?vue&type=script&lang=js"
export * from "./AttachmentViewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports